﻿const hubSpotFormFieldTypes = [
  "text",
  "phonenumber",
  "checkbox",
  "select",
  "radio",
  "number",
  "textarea",
  "date",
  "file",
  "booleancheckbox",
] as const;

export type HubSpotFormFieldType = (typeof hubSpotFormFieldTypes)[number];

const FIELD_TYPE_PREFIX = "hs-fieldtype-";

export const getFieldType = (field: Element): HubSpotFormFieldType | undefined => {
  const extractedType = [...field.classList]
    .filter(className => className.startsWith(FIELD_TYPE_PREFIX))[0]
    ?.slice(FIELD_TYPE_PREFIX.length);

  if (
    !!extractedType &&
    hubSpotFormFieldTypes.includes(extractedType as HubSpotFormFieldType)
  ) {
    return extractedType as HubSpotFormFieldType;
  }

  return undefined;
};
